import { type Provider } from '@angular/core';
import { ToolType } from '@bizzdesign/bizzdesign-sdk';
import { FrameFactoryService } from './services/frame-factory.service';
import { WorkspaceFactoryService } from './services/workspace-factory.service';
import {
  TOOL_SPEC_REGISTER,
  type ToolSpecRegister,
} from './tokens/tool-spec-register.token';

const toolSpecRegister: ToolSpecRegister = {
  [ToolType.DESIGN]: {
    containerType: () =>
      import('@bizzdesign/modeler/api-workspaces').then(
        (m) => m.ModelerWrapperComponent,
      ),
    inputsFactoryType: () =>
      import('@bizzdesign/modeler/api-workspaces').then(
        (m) => m.ModelerInputsFactoryService,
      ),
  },
  [ToolType.INSIGHT]: {
    containerType: () =>
      import('@bizzdesign/feature-highcharts').then(
        (m) => m.HighchartsContainerComponent,
      ),
    inputsFactoryType: () =>
      import('@bizzdesign/data-access-highcharts').then(
        (m) => m.HighchartsInputsFactoryService,
      ),
  },
};

const TOOL_SPEC_REGISTER_PROVIDER: Provider = {
  provide: TOOL_SPEC_REGISTER,
  useValue: toolSpecRegister,
};

export const WORKSPACES_SHARED_PROVIDERS: Provider[] = [
  TOOL_SPEC_REGISTER_PROVIDER,
  { provide: WorkspaceFactoryService, useClass: WorkspaceFactoryService },
  { provide: FrameFactoryService, useClass: FrameFactoryService },
];
